export default "__VITE_ASSET__mz9Hy4Lf__"